import {AuthGuardOffline} from "../theme/guards/AuthGuardOffline";
import {Outlet} from "react-router-dom";

export function ViteAuthGuardOffline() {
    return (
        <AuthGuardOffline><Outlet/></AuthGuardOffline>
    )
}